import Vue from 'vue'
import App from './App.vue'
import Notifications from 'vue-notification'
import VueI18n from 'vue-i18n';
import { VLazyImagePlugin } from "v-lazy-image";
import Datetime from 'vue-datetime';
import Loading from './js/Loading';
import 'animate.css/animate.min.css';
import 'vue-datetime/dist/vue-datetime.css';
import { languages } from '../static/translation/index.js';


import 'atvimg/atvImg.css';
import 'atvimg/atvImg';


require('intersection-observer');

IntersectionObserver.prototype.POLL_INTERVAL = 100;

Vue.use(Notifications);
Vue.use(VLazyImagePlugin);
Vue.use(Datetime);
Vue.use(VueI18n);

var defaultLocale = (window.navigator.userLanguage || window.navigator.language).replace('-','_');
if(defaultLocale.length == 2){
  defaultLocale += '_'+defaultLocale.toUpperCase();
}

const messages = Object.assign(languages);

export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'en_US',
  messages
});

Vue.config.productionTip = false
Vue.prototype.$loading = new Loading();

Vue.prototype.$globalStoreHelpers = new Vue({
  data: {
    isValidHex: (hex) => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex),
    hexToRGBA: (hex, alpha) => {

      function isValidHex(hex) {
        return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex)
      }

      function getChunksFromString(st, chunkSize) {
        return st.match(new RegExp(`.{${chunkSize}}`, "g"))
      }

      function convertHexUnitTo256(hexStr) {
        return parseInt(hexStr.repeat(2 / hexStr.length), 16)
      }

      function getAlphafloat(a, alpha) {
        if (typeof a !== "undefined") {
          return a / 256
        }
        if (typeof alpha !== "undefined") {
          if (1 < alpha && alpha <= 100) {
            return alpha / 100
          }
          if (0 <= alpha && alpha <= 1) {
            return alpha
          }
        }
        return 1
      }

      if (!isValidHex(hex)) {
        throw new Error("Invalid HEX")
      }
      const chunkSize = Math.floor((hex.length - 1) / 3);
      const hexArr = getChunksFromString(hex.slice(1), chunkSize);
      const [r, g, b, a] = hexArr.map(convertHexUnitTo256);
      return `rgba(${r}, ${g}, ${b}, ${getAlphafloat(a, alpha)})`
    }
  },
});

new Vue({
  render: h => h(App), i18n,
}).$mount('#app')


window.mergeRecursive = function (obj1, obj2) {

  for (var p in obj2) {
    try {
      // Property in destination object set; update its value.
      if (obj2[p].constructor == Object) {
        obj1[p] = window.mergeRecursive(obj1[p], obj2[p]);

      } else {
        obj1[p] = obj2[p];

      }

    } catch (e) {
      // Property in destination object not set; create it and set its value.
      obj1[p] = obj2[p];

    }
  }

  return obj1;
}
